'use strict';

bbw.directive.bbwScrollKeep = ['$location', '$window', function($location, $window) {

    var scrollTops = {};

    return {
        link: function(scope, element, attrs) {
            var timeout = attrs.bbwScrollKeep || 2000;
            var destroyed = false;
            var currentUri = $location.url();

            scope.$on('$locationChangeStart', function(event, newValue, oldValue) {
                if (destroyed) {
                    return;
                }
                if (newValue !== oldValue && ('' + oldValue).indexOf(currentUri) > 0) {
                    scrollTops[currentUri] = $window.pageYOffset || 0;
                }
            });
            scope.$on('$destroy', function(event, args) {
                destroyed = true;
            });
            element.on('$destroy', function(event) {
                destroyed = true;
            });

            if (scrollTops[currentUri]) {
                var y = scrollTops[currentUri];
                delete scrollTops[currentUri];
                setTimeout(function() {
                    if (destroyed) {
                        return;
                    }
                    $window.scrollTo(0, y);
                }, timeout);
            }
        }
    };
}];
